import { Color } from '../../../enums/color'
import { NavItemState } from '../types/navItemState'
import { NavItemVariant } from '../types/navItemVariant'

interface ItemStyled {
  backgroundColor?: Color
  borderColor?: Color
  iconLeftColor: Color
  iconRightColor: Color
  textColor: Color
  textSecondaryColor: Color
  textSubitemColor: Color
}

const invertedContentColor = Color.Grey50
const invertedActiveBackgroundColor = Color.Green900
const invertedFocusedBorderColor = Color.Green400
const invertedDisabledContentColor = Color.Grey500

export const getStateToStyles = (): Record<NavItemVariant, Record<NavItemState, ItemStyled>> => ({
  primary: {
    default: {
      iconLeftColor: Color.Grey800,
      iconRightColor: Color.Grey500,
      textColor: Color.Grey950,
      textSecondaryColor: Color.Grey950,
      textSubitemColor: Color.Grey950,
    },
    hovered: {
      backgroundColor: Color.Grey100,
      iconLeftColor: Color.Grey800,
      iconRightColor: Color.Grey500,
      textColor: Color.Grey950,
      textSecondaryColor: Color.Grey950,
      textSubitemColor: Color.Grey950,
    },
    expanded: {
      iconLeftColor: Color.Grey800,
      iconRightColor: Color.Grey500,
      textColor: Color.Grey950,
      textSecondaryColor: Color.Grey950,
      textSubitemColor: Color.Grey950,
    },
    focused: {
      borderColor: Color.Lavender500,
      iconLeftColor: Color.Grey800,
      iconRightColor: Color.Grey500,
      textColor: Color.Grey950,
      textSecondaryColor: Color.Grey950,
      textSubitemColor: Color.Grey950,
    },
    selected: {
      backgroundColor: Color.Grey100,
      iconLeftColor: Color.Grey800,
      iconRightColor: Color.Grey500,
      textColor: Color.Grey950,
      textSecondaryColor: Color.Grey950,
      textSubitemColor: Color.Grey950,
    },
    suggested: {
      backgroundColor: Color.Lavender50,
      iconLeftColor: Color.Lavender700,
      iconRightColor: Color.Grey500,
      textColor: Color.Lavender700,
      textSecondaryColor: Color.Lavender700,
      textSubitemColor: Color.Lavender700,
    },
    disabled: {
      backgroundColor: Color.Grey100,
      iconLeftColor: Color.Grey400,
      iconRightColor: Color.Grey400,
      textColor: Color.Grey400,
      textSecondaryColor: Color.Grey400,
      textSubitemColor: Color.Grey400,
    },
  },
  danger: {
    default: {
      iconLeftColor: Color.Red700,
      iconRightColor: Color.Grey500,
      textColor: Color.Red700,
      textSecondaryColor: Color.Red700,
      textSubitemColor: Color.Red700,
    },
    hovered: {
      backgroundColor: Color.Grey100,
      iconLeftColor: Color.Red700,
      iconRightColor: Color.Grey500,
      textColor: Color.Red700,
      textSecondaryColor: Color.Red700,
      textSubitemColor: Color.Red700,
    },
    expanded: {
      iconLeftColor: Color.Red700,
      iconRightColor: Color.Grey500,
      textColor: Color.Red700,
      textSecondaryColor: Color.Red700,
      textSubitemColor: Color.Red700,
    },
    focused: {
      borderColor: Color.Black,
      iconLeftColor: Color.Red700,
      iconRightColor: Color.Grey500,
      textColor: Color.Red700,
      textSecondaryColor: Color.Red700,
      textSubitemColor: Color.Red700,
    },
    selected: {
      backgroundColor: Color.Grey100,
      iconLeftColor: Color.Red700,
      iconRightColor: Color.Grey500,
      textColor: Color.Red700,
      textSecondaryColor: Color.Red700,
      textSubitemColor: Color.Red700,
    },
    suggested: {
      backgroundColor: Color.Lavender50,
      iconLeftColor: Color.Lavender700,
      iconRightColor: Color.Grey500,
      textColor: Color.Lavender700,
      textSecondaryColor: Color.Lavender700,
      textSubitemColor: Color.Lavender700,
    },
    disabled: {
      iconLeftColor: Color.Grey400,
      iconRightColor: Color.Grey400,
      textColor: Color.Grey400,
      textSecondaryColor: Color.Grey400,
      textSubitemColor: Color.Grey400,
    },
  },
  inverted: {
    default: {
      iconLeftColor: invertedContentColor,
      iconRightColor: invertedContentColor,
      textColor: invertedContentColor,
      textSecondaryColor: invertedContentColor,
      textSubitemColor: invertedContentColor,
    },
    hovered: {
      backgroundColor: invertedActiveBackgroundColor,
      iconLeftColor: invertedContentColor,
      iconRightColor: invertedContentColor,
      textColor: invertedContentColor,
      textSecondaryColor: invertedContentColor,
      textSubitemColor: invertedContentColor,
    },
    expanded: {
      iconLeftColor: invertedContentColor,
      iconRightColor: invertedContentColor,
      textColor: invertedContentColor,
      textSecondaryColor: invertedContentColor,
      textSubitemColor: invertedContentColor,
    },
    focused: {
      borderColor: invertedFocusedBorderColor,
      iconLeftColor: invertedContentColor,
      iconRightColor: invertedContentColor,
      textColor: invertedContentColor,
      textSecondaryColor: invertedContentColor,
      textSubitemColor: invertedContentColor,
    },
    selected: {
      backgroundColor: invertedActiveBackgroundColor,
      iconLeftColor: invertedContentColor,
      iconRightColor: invertedContentColor,
      textColor: invertedContentColor,
      textSecondaryColor: invertedContentColor,
      textSubitemColor: invertedContentColor,
    },
    suggested: {
      backgroundColor: invertedActiveBackgroundColor,
      iconLeftColor: invertedContentColor,
      iconRightColor: invertedContentColor,
      textColor: invertedContentColor,
      textSecondaryColor: invertedContentColor,
      textSubitemColor: invertedContentColor,
    },
    disabled: {
      iconLeftColor: invertedDisabledContentColor,
      iconRightColor: invertedDisabledContentColor,
      textColor: invertedDisabledContentColor,
      textSecondaryColor: invertedDisabledContentColor,
      textSubitemColor: invertedDisabledContentColor,
    },
  },
})
